import { Component } from "react"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
// import "./styles.css"
import Colors from "../../common/Colors"
import routes from "../../routes/URL"
import { Button, TextField, CardContent, CardHeader, Box, Typography, Container } from "@mui/material"
import IsolatedStatusModal from "../../components/StatusModal"
import Toast from "../../components/Toast"
import Header from "../../components/Header"

class ListHotelScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toast: {
        open: false,
        message: "",
        severity: "success" 
      }      
    }
  }

  componentDidMount() { }

  create = async () => {
    const formdata = new FormData(document.getElementById("hotelForm"))
    formdata.append("hotel_id", this.props.selectedHotelId.id)
    formdata.append("tax_rate", this.state.taxRate) // Add tax rate to form data
    console.log([...formdata.entries()]) // Better logging of FormData
    
    const { status, message, data } = await API(this, "post", URL_PATH.createFloor, formdata)

    if (status == "success") {
      this.setState({
        toast: {
          open: true,
          message: message,
          severity: "success"
        }
      });
      setTimeout(() => {
        this.props.history.push(routes.admin.floors.list);
      }, 2000); // Redirect after 2 seconds
    } else {
      this.setState({
        toast: {
          open: true,
          message: message,
          severity: "error"
        }
      });
    }
  };

  handleTaxRateChange = (e) => {
    this.setState({ taxRate: e.target.value })
  }

  handleSuccessModalClose = () => {
    this.setState({ showSuccessModal: false })
    this.props.history.push(routes.admin.floors.list)
  }

  handleErrorModalClose = () => {
    this.setState({ showErrorModal: false })
  }

  render() {
    return (
      <Container maxWidth="lg" className="py-5">
        <Box
          sx={{ 
            borderRadius: "10px",
            overflow: "hidden",
            bgcolor: "transparent",
            border: "1px solid #FFC857",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        > 
          
           <CardHeader
                      title={
                        <Header title="Create Space" />
          
                      }
                      sx={{ pb: 2 }}
                    />
          <CardContent sx={{}}>
            <form
              id="hotelForm"
              name="hotelForm"
              onSubmit={(e) => {
                e.preventDefault()
                return this.create()
              }}
            >
              <Box mb={3}>
                <TextField
                  fullWidth
                  id="floor_no"
                  name="floor_no"
                  label="Space Name"
                  placeholder="Enter Space Name"
                  variant="outlined"
                  required
                  InputProps={{
                    sx: {
                      borderRadius: 1,
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white !important',
                      },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      '&.Mui-focused': {
                        color: 'white !important',
                      },
                    },
                  }}
                />
              </Box>

              <Box mb={3}>
                <TextField
                  fullWidth
                  id="tax_rate"
                  name="tax_rate"
                  label="Tax Rate (%)"
                  placeholder="Enter Tax Rate"
                  variant="outlined"
                  type="number"
                  value={this.state.taxRate}
                  onChange={this.handleTaxRateChange}
                  InputProps={{
                    sx: {
                      borderRadius: 1,
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white !important',
                      },
                      input: {
                        inputMode: 'numeric',
                        pattern: '[0-9]*'
                      }
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      '&.Mui-focused': {
                        color: 'white !important',
                      },
                    },
                  }}
                />
              </Box>

              <Box mt={4} display="flex" justifyContent="flex-start">
                <Button
                  variant="contained"
                  type="submit"
                  size="large"
                  sx={{
                    px: 4,
                    py: 1,
                    borderRadius: 1,
                    textTransform: "none",
                    fontWeight: 700,
                    bgcolor: "#FFC857",
                    "&:hover": {
                      bgcolor: "#E6B54E",
                    },
                  }}
                >
                  Submit
                </Button>
              </Box>
            </form>
          </CardContent>
        </Box>

        <Toast
        open={this.state.toast.open}
        message={this.state.toast.message}
        severity={this.state.toast.severity}
        handleClose={() => this.setState({ toast: { ...this.state.toast, open: false } })}
      />
        
      </Container>
    )
  }
}

export default redux(ListHotelScreen)







// import { Component } from "react"
// import API, { URL_PATH } from "../../services/API"
// import redux from "../../common/Redux"
// import "./styles.css"
// import Colors from "../../common/Colors"
// import routes from "../../routes/URL"


// import OneSignal from "react-onesignal"
// import {
//   Box,
//   Container,
//   Typography,
//   TextField,
//   Button,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   FormControl,
//   FormLabel,
//   InputAdornment,
//   Card,
//   CardContent,
//   Lock
// } from "@mui/material"
// import { Email, Phone, Person, Refresh, ArrowForward } from "@mui/icons-material"
// import Constant from "../../common/Constant"
// import IsolatedStatusModal from "../../components/StatusModal"
// import Toast from "../../components/Toast"

// const errors = {
//   uname: "invalid username",
//   pass: "invalid mobile",
// }
// class ListHotelScreen extends Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       error: null,
//       isLoaded: false,
//       active: "login",
//       otp: "",
//       email: "",
//       mobile: "",
//       name: "",
//       user_id:"dd5a0f90-cef8-42d8-aebb-b9dabde9537e",
//       user_type: "hotel",
//       sendingOTP: false,
//       modalOpen: false,
//       modalType: "success",
//       modalTitle: "",
//       modalMessage: "",
//       toast: {
//         open: false,
//         message: "",
//         severity: "success"
//       }
//     }
//   }

//   showToast = (message, severity = "success") => {
//     this.setState({
//       toast: {
//         open: true,
//         message,
//         severity
//       }
//     })
//   }
  
//   handleCloseToast = (event, reason) => {
//     if (reason === 'clickaway') {
//       return
//     }
//     this.setState({
//       toast: {
//         ...this.state.toast,
//         open: false
//       }
//     })
//   }

//   componentDidMount() {
//     console.log("alllllled")
//     // this.props.history.push("/user/profile");
//     const token = localStorage.getItem("token")
//     if (token && this.props.isAuth) {
//       this.props.history.push(routes.admin.dashboard)
//     }
//   }

//   showModal = (type, title, message) => {
//     this.setState({
//       modalOpen: true,
//       modalType: type,
//       modalTitle: title,
//       modalMessage: message,
//     })
//   }

//   closeModal = () => {
//     this.setState({ modalOpen: false })
//   }
//   sendOTP = async (event) => {
//     // Prevent page reload
//     event.preventDefault();
    
//     // Create form data object similar to mobile app
//     const fd = {
//       user_type: "hotel", // Matching mobile app's constants.user_type
//     };
  
//     // Get email/mobile value
//     const emailPhone = event.target.email.value;
    
//     // Set check_for and appropriate field
//     if (emailPhone.includes("@")) {
//       fd.check_for = "email";
//       fd.email = emailPhone;
//     } else {
//       fd.check_for = "mobile";
//       fd.mobile = emailPhone;
//     }
  
//     // Make API call
//     const { status, message, data } = await API(
//       this,
//       "post",
//       URL_PATH.login,
//       fd
//     );
  
//     // Handle responses
//     if (status == "error") {
//       return this.showModal("error", "Error", message);
//     } 
//     else if (status == "redirect") {
//       window.location.href = data; // Using window.location instead of Linking.openURL for web
//       return;
//     }
//     else if (status == "success") {
//       const {
//         otp_length,
//         name,
//         email,
//         mobile,
//         token,
//         message,
//         signup = false,
//         emailDisabled,
//         mobileDisabled,
//       } = data;
  
//       // Update state similar to mobile app's this.otp(data)
//       this.setState({
//         name,
//         otp_length,
//         token,
//         otpMessage: message,
//         signup,
//         active: "verify",
//         email,
//         mobile,
//         emailDisabled,
//         mobileDisabled,
//       });
//       return;
//     }
  
//     return this.showToast("Something went wrong", "error");
//   };
//   // sendOTP = async (event) => {
//   //   // Prevent page reload
//   //   event.preventDefault()
//   //   // Get form data
//   //   const formData = new FormData(event.target)

//   //   // check is there email or mobile number in the form data
//   //   const emailPhone = formData.get("email")
//   //   if (emailPhone.includes("@")) {
//   //     formData.append("check_for", "email")
//   //   } else {
//   //     formData.append("check_for", "mobile")
//   //   }

//   //   // Validate form data
//   //   const result = await API(this, "post", URL_PATH.login, formData)
//   //   const { status, message, data } = result
//   //   console.log(status, message)
//   //   if (status == "error") {
//   //     return this.showModal("error", "Error", message)
//   //   }
//   //   if (status == "success") {
//   //     const { otp_length, name, email, mobile, token, message, signup = false, emailDisabled, mobileDisabled } = data
//   //     this.setState({
//   //       name,
//   //       otp_length,
//   //       token,
//   //       otpMessage: message,
//   //       signup,
//   //       active: "verify",
//   //       email,
//   //       mobile,
//   //       emailDisabled,
//   //       mobileDisabled,
//   //     })

//   //     return
//   //   }

//   //   return this.showToast("Something went wrong", "error")
//   // }

//   // handleSubmit = async (event) => {
//   //   // Prevent page reload
//   //   event.preventDefault()
//   //   // Get form data
//   //   const formData = new FormData(event.target)

//   //   // Validate form data
//   //   const result = await API(this, "post", URL_PATH.verify_otp, formData)
//   //   const { status, message, data } = result
//   //   if (status == "error") {
//   //     return this.showToast(message, "error")
//   //   }
//   //   if (status == "success") {
//   //     const { otp_length, token, message, signup = false } = data

//   //     this.setState({ otp_length, token, otpMessage: message, signup })

//   //     window.axios.defaults.headers.common["Authorization"] = `Bearer ${data.token}`
//   //     window.axios.defaults.headers.common["userId"] = `${data.user.id}`
//   //     window.axios.defaults.headers.common["user-type"] = `${data.user_type}`

//   //     this.loginSuccess(data)
//   //     return
//   //   }
//   // }
//   handleSubmit = async (event) => {
//     event.preventDefault();
//     const formData = new FormData(event.target);
  
//     try {
//       const result = await API(this, "post", URL_PATH.verify_otp, formData);
//       console.log("Full API Response:", result); // Debugging
  
//       // Handle API-level errors (e.g., invalid OTP)
//       if (result.status === "error" || result.success === false) {
//         const errorMsg = result.message || "Unknown error";
//         return this.showToast(errorMsg, "error");
//       }
  
//       // Handle success
//       if (result.status === "success" || result.success === true) {
//         const { otp_length, token, message, signup = false } = result.data || {};
//         this.setState({ otp_length, token, otpMessage: message, signup });
  
//         // Set Axios headers
//         if (token) {
//           window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
//         }
//         if (result.data?.user?.id) {
//           window.axios.defaults.headers.common["userId"] = `${result.data.user.id}`;
//         }
//         if (result.data?.user_type) {
//           window.axios.defaults.headers.common["user-type"] = `${result.data.user_type}`;
//         }
  
//         this.loginSuccess(result.data);
//       }
//     } catch (error) {
//       console.error("API Call Failed:", error);
//       this.showToast("Failed to verify OTP. Please try again.", "error");
//     }
//   };

//   loginSuccess = (data) => {
//     localStorage.setItem("token", data.token)
//     localStorage.setItem("user", JSON.stringify(data.user))
//     localStorage.setItem("user_type", data.user_type)
//     this.props.setAccessControl(data.access_control)
//     this.props.setSubscriptionActive(data.subscription_active)
//     this.props.setAuth(true)
//     this.props.setUser(data.user)
//     OneSignal.setExternalUserId(data.user.id)
//     OneSignal.sendTag("user_type", Constant.user_type)
//     this.props.history.push("/dashboard")
//   }

//   renderErrorMessage = (name) => {
//     return <div className="error-message">{errors[name]}</div>
//   }
//   LoginBox() {
//     return (
//       <form onSubmit={(e) => this.sendOTP(e)} id="login-form">
//         <TextField
//           fullWidth
//           name="email"
//           label="Email/Mobile"
//           variant="outlined"
//           margin="normal"
//           value={this.state.email}
//           onChange={(e) => this.setState({ email: e.target.value })}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <Person sx={{ color: "white" }} />
//               </InputAdornment>
//             ),
//           }}
//           InputLabelProps={{
//             style: { color: "white" },
//           }}
//           sx={{
//             mb: 3,
//             "& .MuiOutlinedInput-root": {
//               "& fieldset": {
//                 borderColor: "rgba(255, 255, 255, 0.3)",
//               },
//               "&:hover fieldset": {
//                 borderColor: "white",
//               },
//               "&.Mui-focused fieldset": {
//                 borderColor: Colors.primary,
//               },
//               color: "white",
//             },
//           }}
//         />
  
//         <Button
//           type="submit"
//           fullWidth
//           variant="contained"
//           size="large"
//           endIcon={<ArrowForward />}
//           sx={{
//             mt: 1,
//             mb: 2,
//             backgroundColor: Colors.primary,
//             color: "black",
//             fontWeight: "bold",
//             "&:hover": {
//               backgroundColor: Colors.primary,
//               opacity: 0.9,
//             },
//           }}
//         >
//           Continue
//         </Button>
//       </form>
//     )
//   }
//   // LoginBox() {
//   //   return (
//   //     <form onSubmit={(e) => this.sendOTP(e)} id="login-form">
//   //       <FormControl component="fieldset" className="" fullWidth>
//   //         <FormLabel component="legend" sx={{ color: "white" }}>
//   //           Login Type
//   //         </FormLabel>
//   //         <RadioGroup
//   //           row
//   //           name="user_type"
//   //           value={this.state.user_type}
//   //           onChange={(e) => this.setState({ user_type: e.target.value })}
//   //         >
//   //           <FormControlLabel
//   //             value="hotel"
//   //             control={
//   //               <Radio
//   //                 sx={{
//   //                   color: "white",
//   //                   "&.Mui-checked": {
//   //                     color: Colors.primary,
//   //                   },
//   //                 }}
//   //               />
//   //             }
//   //             label={<Typography sx={{ color: "white" }}>Admin</Typography>}
//   //           />
//   //           <FormControlLabel
//   //             value="hotel-user"
//   //             control={
//   //               <Radio
//   //                 sx={{
//   //                   color: "white",
//   //                   "&.Mui-checked": {
//   //                     color: Colors.primary,
//   //                   },
//   //                 }}
//   //               />
//   //             }
//   //             label={<Typography sx={{ color: "white" }}>Staff</Typography>}
//   //           />
//   //         </RadioGroup>
//   //       </FormControl>

//   //       <TextField
//   //         fullWidth
//   //         name="email"
//   //         label="Email/Mobile"
//   //         variant="outlined"
//   //         margin="normal"
//   //         value={this.state.email}
//   //         onChange={(e) => this.setState({ email: e.target.value })}
//   //         InputProps={{
//   //           startAdornment: (
//   //             <InputAdornment position="start">
//   //             <Person sx={{ color: "white" }} />
//   //           </InputAdornment>
            
//   //           ),
//   //         }}
//   //         InputLabelProps={{
//   //           style: { color: "white" },
//   //         }}
//   //         sx={{
//   //           mb: 3,
//   //           "& .MuiOutlinedInput-root": {
//   //             "& fieldset": {
//   //               borderColor: "rgba(255, 255, 255, 0.3)",
//   //             },
//   //             "&:hover fieldset": {
//   //               borderColor: "white",
//   //             },
//   //             "&.Mui-focused fieldset": {
//   //               borderColor: Colors.primary,
//   //             },
//   //             color: "white",
//   //             // backgroundColor: "rgba(7, 7, 10, 0.8)",
//   //           },
//   //         }}
//   //       />

//   //       <Button
//   //         type="submit"
//   //         fullWidth
//   //         variant="contained"
//   //         size="large"
//   //         endIcon={<ArrowForward />}
//   //         sx={{
//   //           mt: 1,
//   //           mb: 2,
//   //           backgroundColor: Colors.primary,
//   //           color: "black",
//   //           fontWeight: "bold",
//   //           "&:hover": {
//   //             backgroundColor: Colors.primary,
//   //             opacity: 0.9,
//   //           },
//   //         }}
//   //       >
//   //         Continue
//   //       </Button>
//   //     </form>
//   //   )
//   // }

//   SignUpBox() {
//     return (
//       <form onSubmit={(e) => this.handleSubmit(e)} id="login-form">
//         <TextField
//           fullWidth
//           name="name"
//           label="Name"
//           variant="outlined"
//           margin="normal"
//           value={this.state.name}
//           onChange={(e) => this.setState({ name: e.target.value })}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <Person sx={{ color: "white" }} />
//               </InputAdornment>
//             ),
//           }}
//           InputLabelProps={{
//             style: { color: "white" },
//           }}
//           sx={{
//             mb: 2,
//             "& .MuiOutlinedInput-root": {
//               "& fieldset": {
//                 borderColor: "rgba(255, 255, 255, 0.3)",
//               },
//               "&:hover fieldset": {
//                 borderColor: "white",
//               },
//               "&.Mui-focused fieldset": {
//                 borderColor: Colors.primary,
//               },
//               color: "white",
//               // backgroundColor: "rgba(7, 7, 10, 0.8)",
//             },
//           }}
//         />

//         <TextField
//           fullWidth
//           name="email"
//           label="Email (username)"
//           variant="outlined"
//           margin="normal"
//           value={this.state.email}
//           onChange={(e) => this.setState({ email: e.target.value })}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <Email sx={{ color: "white" }} />
//               </InputAdornment>
//             ),
//           }}
//           InputLabelProps={{
//             style: { color: "white" },
//           }}
//           sx={{
//             mb: 2,
//             "& .MuiOutlinedInput-root": {
//               "& fieldset": {
//                 borderColor: "rgba(255, 255, 255, 0.3)",
//               },
//               "&:hover fieldset": {
//                 borderColor: "white",
//               },
//               "&.Mui-focused fieldset": {
//                 borderColor: Colors.primary,
//               },
//               color: "white",
//               // backgroundColor: "rgba(7, 7, 10, 0.8)",
//             },
//           }}
//         />

//         <TextField
//           fullWidth
//           name="mobile"
//           label="Mobile Number"
//           variant="outlined"
//           margin="normal"
//           value={this.state.mobile}
//           onChange={(e) => this.setState({ mobile: e.target.value })}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <Phone sx={{ color: "white" }} />
//               </InputAdornment>
//             ),
//           }}
//           InputLabelProps={{
//             style: { color: "white" },
//           }}
//           sx={{
//             mb: 3,
//             "& .MuiOutlinedInput-root": {
//               "& fieldset": {
//                 borderColor: "rgba(255, 255, 255, 0.3)",
//               },
//               "&:hover fieldset": {
//                 borderColor: "white",
//               },
//               "&.Mui-focused fieldset": {
//                 borderColor: Colors.primary,
//               },
//               color: "white",
//               // backgroundColor: "rgba(7, 7, 10, 0.8)",
//             },
//           }}
//         />

//         <input type="hidden" name="user_type" value="hotel" />

//         <Button
//           type="submit"
//           fullWidth
//           variant="contained"
//           size="large"
//           endIcon={<ArrowForward />}
//           sx={{
//             mt: 1,
//             mb: 2,
//             backgroundColor: Colors.primary,
//             color: "black",
//             fontWeight: "bold",
//             "&:hover": {
//               backgroundColor: Colors.primary,
//               opacity: 0.9,
//             },
//           }}
//         >
//           Submit
//         </Button>
//       </form>
//     )
//   }

//   VerifyBox() {
//     const {
//       otp_length,
//       token,
//       otp,
//       otpMessage,
//       signup = false,
//       emailDisabled = false,
//       mobileDisabled = false,
//       sendingOTP,
//     } = this.state

//     return (
//       <form onSubmit={(e) => this.handleSubmit(e)} id="login-form">
//         <input type="hidden" name="key" value={token} />

//         <Box sx={{ mb: 3, mt: 2 }}>
//           <Typography variant="body1" sx={{ color: "white", mb: 2, mt: 2 }}>
//             {otpMessage}
//           </Typography>

//           <TextField
//             fullWidth
//             name="otp"
//             label="Verification Code"
//             variant="outlined"
//             type="number"
//             inputProps={{
//               maxLength: otp_length,
//               minLength: otp_length,
//             }}
//             value={otp}
//             onChange={(e) => this.setState({ otp: e.target.value })}
//             InputLabelProps={{
//               style: { color: "white" },
//             }}
//             sx={{
//               mb: 2,
//               "& .MuiOutlinedInput-root": {
//                 "& fieldset": {
//                   borderColor: "rgba(255, 255, 255, 0.3)",
//                 },
//                 "&:hover fieldset": {
//                   borderColor: "white",
//                 },
//                 "&.Mui-focused fieldset": {
//                   borderColor: Colors.primary,
//                 },
//                 color: "white",
//                 // backgroundColor: "rgba(7, 7, 10, 0.8)",
//               },
//             }}
//           />

//           <Button
//             variant="text"
//             startIcon={<Refresh />}
//             disabled={sendingOTP}
//             onClick={async () => {
//               this.setState({ sendingOTP: true, otp: "" })
//               const result = await API(this, "post", URL_PATH.resendOtp, { key: token })
//               const { status, data, message } = result
//               if (status == "success") {
//                 this.setState({
//                   token: data.token,
//                   sendingOTP: false,
//                 })
//               } else {
//                 this.showToast(message, "error")
//                 this.setState({ sendingOTP: false })
//               }
//             }}
//             sx={{
//               color: Colors.primary,
//               textTransform: "none",
//               "&:hover": {
//                 backgroundColor: "rgba(255, 255, 255, 0.05)",
//               },
//             }}
//           >
//             Resend OTP
//           </Button>
//         </Box>

//         {signup == false && (
//           <>
//             <TextField
//               fullWidth
//               name="name"
//               label="Name"
//               variant="outlined"
//               margin="normal"
//               value={this.state.name}
//               onChange={(e) => this.setState({ name: e.target.value })}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Person sx={{ color: "white" }} />
//                   </InputAdornment>
//                 ),
//               }}
//               InputLabelProps={{
//                 style: { color: "white" },
//               }}
//               sx={{
//                 mb: 2,
//                 "& .MuiOutlinedInput-root": {
//                   "& fieldset": {
//                     borderColor: "rgba(255, 255, 255, 0.3)",
//                   },
//                   "&:hover fieldset": {
//                     borderColor: "white",
//                   },
//                   "&.Mui-focused fieldset": {
//                     borderColor: Colors.primary,
//                   },
//                   color: "white",
//                   // backgroundColor: "rgba(7, 7, 10, 0.8)",
//                 },
//               }}
//             />

//             <TextField
//               fullWidth
//               name="email"
//               label="Email"
//               variant="outlined"
//               margin="normal"
//               value={this.state.email}
//               onChange={(e) => this.setState({ email: e.target.value })}
//               disabled={emailDisabled}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Email sx={{ color: emailDisabled ? "gray" : "white" }} />
//                   </InputAdornment>
//                 ),
//               }}
//               InputLabelProps={{
//                 style: { color: emailDisabled ? "gray" : "white" },
//               }}
//               sx={{
//                 mb: 2,
//                 "& .MuiOutlinedInput-root": {
//                   "& fieldset": {
//                     borderColor: "rgba(255, 255, 255, 0.3)",
//                   },
//                   "&:hover fieldset": {
//                     borderColor: emailDisabled ? "gray" : "white",
//                   },
//                   "&.Mui-focused fieldset": {
//                     borderColor: emailDisabled ? "gray" : Colors.primary,
//                   },
//                   color: emailDisabled ? "gray" : "white",
//                   // backgroundColor: "rgba(7, 7, 10, 0.8)",
//                 },
//               }}
//             />

//             <TextField
//               fullWidth
//               name="mobile"
//               label="Mobile Number"
//               variant="outlined"
//               margin="normal"
//               value={this.state.mobile}
//               onChange={(e) => this.setState({ mobile: e.target.value })}
//               disabled={mobileDisabled}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Phone sx={{ color: mobileDisabled ? "gray" : "white" }} />
//                   </InputAdornment>
//                 ),
//               }}
//               InputLabelProps={{
//                 style: { color: mobileDisabled ? "gray" : "white" },
//               }}
//               sx={{
//                 mb: 3,
//                 "& .MuiOutlinedInput-root": {
//                   "& fieldset": {
//                     borderColor: "rgba(255, 255, 255, 0.3)",
//                   },
//                   "&:hover fieldset": {
//                     borderColor: mobileDisabled ? "gray" : "white",
//                   },
//                   "&.Mui-focused fieldset": {
//                     borderColor: mobileDisabled ? "gray" : Colors.primary,
//                   },
//                   color: mobileDisabled ? "gray" : "white",
//                   // backgroundColor: "rgba(7, 7, 10, 0.8)",
//                 },
//               }}
//             />



//             <input type="hidden" name="user_type" value="hotel" />
//           </>
//         )}

//         <Button
//           type="submit"
//           fullWidth
//           variant="contained"
//           size="large"
//           endIcon={<ArrowForward />}
//           sx={{
//             mt: 1,
//             mb: 2,
//             backgroundColor: Colors.primary,
//             color: "black",
//             fontWeight: "bold",
//             "&:hover": {
//               backgroundColor: Colors.primary,
//               opacity: 0.9,
//             },
//           }}
//         >
//           Continue
//         </Button>
//       </form>
//     )
//   }

//   RenderBox() {
//     if (this.state.active == "login") return this.LoginBox()
//     if (this.state.active == "signup") return this.SignUpBox()
//     if (this.state.active == "verify") return this.VerifyBox()
//   }

//   render() {
//     return (
//       <div className="login-screen">
//         <Toast
//         open={this.state.toast.open}
//         message={this.state.toast.message}
//         severity={this.state.toast.severity}
//         handleClose={this.handleCloseToast}
//       />
// <Container
//   maxWidth="sm"
//   sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}
// >
//   <Card
//     elevation={8}
//     sx={{
//       backgroundColor: "transparent",
//       backgroundImage: "none",
//       border: "1px solid #FFC857",
//       borderRadius: "5px",
//       width: "100%",
//       maxWidth: { xs: "100%", sm: "450px" },
//       overflow: "visible",
//     }}
//   >
//     <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
//       <Box sx={{ display: "flex", justifyContent: "center", mb: 4 }}>
//         <img src="/logo2.png" alt="logo" className="logo" width="150" />
//       </Box>

//       {this.RenderBox()}

//       {this.state.active == "verify" && (
//         <Box sx={{ mt: 3, textAlign: "center" }}>
//           <Typography variant="body2" sx={{ color: "white", mb: 1 }}>
//             {this.state.active == "login"
//               ? "Don't have an account"
//               : this.state.active == "signup"
//               ? "Already have an account"
//               : "Login With another Account"}
//           </Typography>
//           <Typography
//             variant="body2"
//             onClick={() => {
//               this.setState({
//                 active:
//                   this.state.active == "login"
//                     ? "signup"
//                     : this.state.active == "signup"
//                     ? "login"
//                     : "login",
//               });
//             }}
//             sx={{
//               color: Colors.primary,
//               cursor: "pointer",
//               fontWeight: "medium",
//               "&:hover": {
//                 textDecoration: "underline",
//               },
//             }}
//           >
//             {this.state.active == "login"
//               ? "Register"
//               : this.state.active == "signup"
//               ? "Login"
//               : "Back to Login"}
//           </Typography>
//         </Box>
//       )}

//       {/* Terms and Privacy Policy inside Card */}
    
//     </CardContent>
//   </Card>
// </Container>
//   <Box
//         sx={{
//           textAlign: "center",
//           mt: 4,
//           pt: 2,
//           borderTop: "1px solid #333",
//         }}
//       >
//         <Typography variant="body2" sx={{ color: "#9ca3af", fontSize: "14px", mb: 1 }}>
//           By Continuing, you agree to our
//         </Typography>
//         <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
//              <a
//             href="https://etable.co.in/about-etable/"
//             style={{
//               textDecoration: "none",
//               fontSize: "14px",
//               color: Colors.primary, // optional: you can define Colors.primary
//             }}
//           >
//             About Us
//           </a>
//              <a
//             href="https://etable.co.in/contact-us/"
//             style={{
//               textDecoration: "none",
//               fontSize: "14px",
//               color: Colors.primary, // optional: you can define Colors.primary
//             }}
//           >
//            Contact Us
//           </a>
//           <a
//             href="https://etable.co.in/terms-conditions/"
//             style={{
//               textDecoration: "none",
//               fontSize: "14px",
//               color: Colors.primary, // optional: you can define Colors.primary
//             }}
//           >
//             Terms and Conditions
//           </a>
//           <a
//             href="https://etable.co.in/privacy-policy-2/"
//             style={{
//               textDecoration: "none",
//               fontSize: "14px",
//               color: Colors.primary, // optional: you can define Colors.primary
//             }}
//           >
//             Privacy Policy
//           </a>
//           <a
//             href="https://etable.co.in/refund-cancellation-policy/"
//             style={{
//               textDecoration: "none",
//               fontSize: "14px",
//               color: Colors.primary, // optional: you can define Colors.primary
//             }}
//           >
//             Refund Policy
//           </a>
//                     <a
//             href="https://etable.co.in/"
//             style={{
//               textDecoration: "none",
//               fontSize: "14px",
//               color: Colors.primary, // optional: you can define Colors.primary
//             }}
//           >
//            Etable Website
//           </a>
//         </Box>
//       </Box>

//          <IsolatedStatusModal
//                   isOpen={this.state.modalOpen}
//                   onClose={this.closeModal}
//                   type={this.state.modalType}
//                   title={this.state.modalTitle}
//                   message={this.state.modalMessage}
//                   buttonText="OK"
//                 />

//       </div>
//     )
//   }
// }

// export default redux(ListHotelScreen)